// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type SchemaTableListQueryVariables = Types.Exact<{
  databaseId: Types.Scalars["ID"]["input"];
  parentTableId?: Types.InputMaybe<Types.Scalars["ID"]["input"]>;
  offset?: Types.InputMaybe<Types.Scalars["Int"]["input"]>;
  limit?: Types.InputMaybe<Types.Scalars["Int"]["input"]>;
  filter?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  sortBy?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  sortDirection?: Types.InputMaybe<Types.SortDirection>;
  includePartitions?: Types.InputMaybe<Types.Scalars["Boolean"]["input"]>;
}>;

export type SchemaTableListQuery = {
  __typename?: "GraphqlQuery";
  getSchemaTables: Array<{
    __typename?: "SchemaTable";
    id: string;
    schemaName: string;
    tableName: string;
    partitionBoundary?: string | null;
    lastStats?: {
      __typename?: "SchemaTableInlineStats";
      snapshotAt?: number | null;
      dataSizeBytes?: number | null;
      indexSizeBytes?: number | null;
      liveTuples?: number | null;
      deadTupleRatio?: number | null;
    } | null;
    stats7dAgo?: {
      __typename?: "SchemaTableInlineStats";
      snapshotAt?: number | null;
      dataSizeBytes?: number | null;
    } | null;
    issues: Array<{
      __typename?: "Issue";
      id: string;
      state: string;
      description: string;
      severity: string;
      references: Array<{ __typename?: "IssueReference"; name: string }>;
    }>;
  }>;
};

export const SchemaTableListDocument = gql`
  query SchemaTableList(
    $databaseId: ID!
    $parentTableId: ID
    $offset: Int
    $limit: Int
    $filter: String
    $sortBy: String
    $sortDirection: SortDirection
    $includePartitions: Boolean
  ) {
    getSchemaTables(
      databaseId: $databaseId
      parentTableId: $parentTableId
      offset: $offset
      limit: $limit
      filter: $filter
      sortBy: $sortBy
      sortDirection: $sortDirection
      includePartitions: $includePartitions
    ) {
      id
      schemaName
      tableName
      partitionBoundary
      lastStats {
        snapshotAt
        dataSizeBytes
        indexSizeBytes
        liveTuples
        deadTupleRatio
      }
      stats7dAgo {
        snapshotAt
        dataSizeBytes
      }
      issues {
        id
        state
        description
        severity
        references {
          name
        }
      }
    }
  }
`;

/**
 * __useSchemaTableListQuery__
 *
 * To run a query within a React component, call `useSchemaTableListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchemaTableListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchemaTableListQuery({
 *   variables: {
 *      databaseId: // value for 'databaseId'
 *      parentTableId: // value for 'parentTableId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *      includePartitions: // value for 'includePartitions'
 *   },
 * });
 */
export function useSchemaTableListQuery(
  baseOptions: Apollo.QueryHookOptions<
    SchemaTableListQuery,
    SchemaTableListQueryVariables
  > &
    (
      | { variables: SchemaTableListQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SchemaTableListQuery, SchemaTableListQueryVariables>(
    SchemaTableListDocument,
    options,
  );
}
export function useSchemaTableListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SchemaTableListQuery,
    SchemaTableListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SchemaTableListQuery,
    SchemaTableListQueryVariables
  >(SchemaTableListDocument, options);
}
// @ts-ignore
export function useSchemaTableListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SchemaTableListQuery,
    SchemaTableListQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  SchemaTableListQuery,
  SchemaTableListQueryVariables
>;
export function useSchemaTableListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SchemaTableListQuery,
        SchemaTableListQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  SchemaTableListQuery | undefined,
  SchemaTableListQueryVariables
>;
export function useSchemaTableListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SchemaTableListQuery,
        SchemaTableListQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SchemaTableListQuery,
    SchemaTableListQueryVariables
  >(SchemaTableListDocument, options);
}
export type SchemaTableListQueryHookResult = ReturnType<
  typeof useSchemaTableListQuery
>;
export type SchemaTableListLazyQueryHookResult = ReturnType<
  typeof useSchemaTableListLazyQuery
>;
export type SchemaTableListSuspenseQueryHookResult = ReturnType<
  typeof useSchemaTableListSuspenseQuery
>;
export type SchemaTableListQueryResult = Apollo.QueryResult<
  SchemaTableListQuery,
  SchemaTableListQueryVariables
>;
